<template>
  <section id="topics" class="section section-observed topic-section cms-layout-cards">
    <p v-if="front.pageSubtitle" class="layout-subtitle">{{ front.pageSubtitle }}</p>

    <div v-if="front.activeBlocks.length" class="cms-blocks">
      <BlockRenderer
        v-for="block in front.activeBlocks"
        :key="block.blockId || block.blockCode"
        :block="block"
        class="cms-block"
      />
    </div>

    <div v-for="group in front.cmsFeatureGroups" :key="group.moduleCode" class="cards-layout-group">
      <div class="cards-layout-group-head">
        <span>{{ group.scopeLabel }}</span>
        <h3>{{ group.label }}</h3>
      </div>
      <div class="cards-layout-grid">
        <button
          v-for="item in group.items"
          :key="item.entryId || item.title"
          type="button"
          class="cards-layout-item"
          @click="front.openCmsEntry(item)"
        >
          <strong>{{ item.title }}</strong>
          <p>{{ item.summary || item.category || '暂无摘要' }}</p>
          <time>{{ item.date || '待发布' }}</time>
        </button>
        <p v-if="!group.items.length" class="muted-copy">暂无已发布内容</p>
      </div>
    </div>

    <CmsEntryDetailPanel v-if="front.selectedCmsEntry" />
  </section>
</template>

<script>
import CmsEntryDetailPanel from '../CmsEntryDetailPanel.vue'
import BlockRenderer from '../blocks/BlockRenderer.vue'

export default {
  name: 'CardsLayout',
  components: { CmsEntryDetailPanel, BlockRenderer },
  inject: ['front']
}
</script>

<style scoped>
.layout-subtitle {
  margin: 12px 0 0;
  color: var(--subtle);
  line-height: 1.8;
}

.cards-layout-group {
  margin-bottom: 32px;
}

.cards-layout-group-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.cards-layout-group-head span {
  border-radius: 999px;
  background: var(--gold-soft);
  color: var(--primary);
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 900;
}

.cards-layout-group-head h3 {
  margin: 0;
  color: var(--primary);
  font-size: 22px;
}

.cards-layout-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.cards-layout-item {
  display: grid;
  gap: 8px;
  min-height: 140px;
  border: 1px solid var(--border);
  border-radius: var(--front-radius);
  padding: 16px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.cards-layout-item:hover {
  border-color: var(--gold);
  background: #fffdf8;
}

.cards-layout-item strong {
  color: var(--primary);
  line-height: 1.45;
}

.cards-layout-item p {
  margin: 0;
  color: var(--subtle);
  font-size: 13px;
  line-height: 1.6;
}

.cards-layout-item time {
  color: var(--secondary);
  font-size: 12px;
}
</style>
